/* eslint-disable camelcase */
export const relayTimetable = {
    title: "Activities",
    relay_timetable: "Relay timetable",
    create_stage: "Create stage",
    export: "Export",
    item_count_one: "{{ count }} item",
    item_count_other: "{{ count }} items",
    invalid_count: "{{ count }} invalid",
    no_issues_found: "No issues found",
    resize_name_column: "Resize name column",
    reset_name_column_hint: "Double-click to reset the name column width",
    columns: {
        number: "#",
        name: "Name",
        fixed_auto: "Fixed / Auto",
        convoy_torch: "Convoy / Torch",
        start: "Start",
        end: "End",
        distance: "Distance",
        speed: "Speed",
        duration: "Duration",
        buffer: "Buffer",
        comments: "Comments",
    },
    stage: {
        invalid_stage: "A segment within the stage is invalid",
        drag_label: "Stage {{ order }}, {{ name }}",
        stage_number: "Stage {{ order }}",
        collapse: "Collapse stage",
        expand: "Expand stage",
        edit_name_for: "Edit name for {{ name }}",
        delete_for: "Delete {{ name }}",
        stage_name: "Stage name",
        name_prefix: "Relay",
        segment_count_one: "{{ count }} segment",
        segment_count_other: "{{ count }} segments",
        selected_of: "{{ selected }} of {{ total }} selected",
    },
    segment: {
        segment_name: "Segment name",
        edit_name_for: "Edit name for {{ name }}",
        start_time_for: "Start time for {{ name }}",
        duration_for: "Duration for {{ name }}",
        buffer_for: "Buffer for {{ name }}",
        comments: "Comments",
        comments_for: "Comments for {{ name }}",
        time_type_for: "Time type for {{ name }}",
        route_type_for: "Route type for {{ name }}",
        speed_for: "Speed for {{ name }}",
        custom_speed_for: "Custom speed for {{ name }}",
    },
    groups: {
        invalid_route_group: "A slot within the group is invalid",
        invalid_transfer_group: "A transfer within the group is invalid",
        collapse_routes: "Collapse routes",
        expand_routes: "Expand routes",
        collapse_transfers: "Collapse transfers",
        expand_transfers: "Expand transfers",
        slots_count: "{{ count }} Slots",
        transfers_count: "{{ count }} transfers",
        transfer_group: "Transfer group",
        transfer: "Transfer",
        transfers: "Transfers",
    },
    route_type: {
        torch: "Torch",
        convoy: "Convoy",
        convoy_and_torch: "Convoy and torch",
        torch_branch: "TORCH",
        convoy_branch: "CONVOY",
    },
    settings: {
        timetable_settings: "Timetable settings",
        close_timetable: "Close timetable",
        close_settings: "Close settings",
        close: "Close",
        view: "View",
        view_description: "What the table checks and how it groups what it shows. Applies to this day only.",
        validation: "Validation",
        validation_description: "Checks re-run on every change and mark the rows at fault.",
        validation_on: "On",
        validation_off: "Off",
        grouping: "Route and transfer rows",
        grouping_description: "Collapses a run of consecutive routes or transfers into one row.",
        grouped_rows: "Grouped rows",
        all_rows: "All rows",
        split_layout: "Split segment layout",
        split_layout_description: "Where torch and convoy part, list them by the clock or lane by lane.",
        chronological: "Chronological",
        by_route: "By route",
        units: "Units",
        units_description: "Distance and speed are chosen independently, so a relay measured in meters can still be run in miles per hour.",
        distance: "Distance",
        distance_description: "Shorter distances drop to the smaller unit of the same system.",
        distance_unit: "Distance unit",
        speed: "Speed",
        speed_description: "How speeds are displayed and entered against a route.",
        speed_unit: "Speed unit",
        kilometers: "Kilometers (km/m)",
        miles: "Miles (mi/ft)",
        mph: "mph",
        kmh: "km/h",
    },
    words: {
        torch: "torch",
        convoy: "convoy",
        auto: "Auto",
        fixed: "Fixed",
        currently: "currently {{ value }}",
        duration: "duration",
        buffer: "buffer",
        invalid: "Invalid.",
    },
    inputs: {
        select_speed: "Select speed",
        disabled_route_type: "A segment must travel with the torch, the convoy or both",
    },
    issues: {
        anchor_overlap: "This item's start time overlaps the end of the item before it.",
        anchor_gap: "This item's start time does not meet the end of the item before it.",
        split_branch_end_mismatch: "The torch and convoy branches need to finish at the same time.",
        split_branch_start_mismatch: "The torch and convoy branches need to start at the same time.",
        missing_duration: "This item has no duration, because the value its selected speed option needs is missing.",
    },
    controls: {
        updating: "Updating {{ label }}",
        reorder: "Reorder {{ label }}",
        zoom_to: "Zoom to {{ label }} on the map",
        fix_split: "Set the {{ field }} for {{ label }} so the torch and convoy branches run alongside one another",
    },
} as const;
